export default __webpack_public_path__ + "static/messagefromtheprincipal-f51e1b74b8a76c569bde17b8eec3d39f.png";